<app-spinner-service></app-spinner-service>

  <div class="content-wrapper">
    <div class="step-card">
      <div class="step-header">
        <div class="step-number">1</div>
        <div class="step-info">
          <h2 class="step-title">Download da Planilha Modelo</h2>
          <p class="step-description">Baixe o modelo de planilha para preencher com os dados das suas NFS-e</p>
        </div>
      </div>
      <div class="step-content">
        <div class="download-section">
          <div class="download-info">
            <i class="pi pi-file-excel download-icon"></i>
            <div class="download-details">
              <h3>Planilha Modelo NFS-e</h3>
              <p>Template com todas as colunas necessárias para importação</p>
              <span class="file-info">Formato: .xlsx | Tamanho: ~15KB</span>
            </div>
          </div>
          <button pButton 
            label="Baixar Planilha Modelo" 
            icon="pi pi-download" 
            (click)="baixarPlanilhaModelo()"
            class="p-button-primary download-button">
          </button>
        </div>
      </div>
    </div>

    <div class="step-card">
      <div class="step-header">
        <div class="step-number">2</div>
        <div class="step-info">
          <h2 class="step-title">Envio da Planilha Preenchida</h2>
          <p class="step-description">Selecione e faça upload da planilha preenchida com os dados das NFS-e</p>
        </div>
      </div>
      <div class="step-content">
        <div class="upload-section">
          <div class="upload-area" 
               [class.has-files]="uploadedFiles.length > 0"
               (click)="triggerFileSelect()"
               (dragover)="onDragOver($event)"
               (dragleave)="onDragLeave($event)"
               (drop)="onDrop($event)">
            
            <div class="upload-content" *ngIf="uploadedFiles.length === 0">
              <i class="pi pi-cloud-upload upload-icon"></i>
              <h3>Selecionar Planilha</h3>
              <p>Arraste e solte sua planilha aqui ou clique para selecionar</p>
              <span class="upload-hint">Formatos aceitos: .xlsx, .xls | Máximo: 5MB</span>
            </div>

            <div class="file-list" *ngIf="uploadedFiles.length > 0">
              <div class="file-item" *ngFor="let file of uploadedFiles; let i = index">
                <div class="file-info">
                  <i class="pi pi-file-excel file-icon"></i>
                  <div class="file-details">
                    <h4>{{ file.name }}</h4>
                    <span>{{ formatFileSize(file.size) }}</span>
                  </div>
                </div>
                <button pButton 
                  icon="pi pi-times" 
                  class="p-button-rounded p-button-danger p-button-sm remove-button"
                  (click)="removeFile(i)">
                </button>
              </div>
            </div>
          </div>

          <input 
            #fileInput
            type="file" 
            accept=".xlsx,.xls" 
            style="display: none;"
            (change)="onFileSelect($event)"
            multiple="false">

          <div class="action-buttons" *ngIf="uploadedFiles.length > 0">
            <button pButton 
              label="Pré-visualizar Planilha" 
              icon="pi pi-eye" 
              class="p-button-info preview-button"
              (click)="preVisualizarPlanilha()">
            </button>
            <button pButton 
              label="Importar Planilha" 
              icon="pi pi-upload" 
              class="p-button-success import-button"
              (click)="uploadArquivo()">
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="step-card" *ngIf="mostrarPreVisualizacao">
      <div class="step-header">
        <div class="step-number">3</div>
        <div class="step-info">
          <h2 class="step-title">Pré-visualização da Planilha</h2>
          <p class="step-description">Verifique os dados antes de importar</p>
        </div>
      </div>
      <div class="step-content">
        <div class="preview-section">
          <div *ngIf="errorMessage" class="error-message">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ errorMessage }}</span>
          </div>

          <div *ngIf="!errorMessage">
            <div class="file-info-preview">
              <h4>Arquivo: {{ nomeArquivo }}</h4>
              <p>Tamanho: {{ formatarTamanhoArquivo(tamanhoArquivo) }}</p>
              <p>Total de registros: {{ dadosPlanilha.length }}</p>
            </div>

            <div class="table-container" *ngIf="dadosPlanilha.length > 0">
              <p-table 
                [value]="dadosPlanilha" 
                [paginator]="true" 
                [rows]="10"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
                [rowsPerPageOptions]="[5, 10, 25]"
                styleClass="p-datatable-sm">
                
                <ng-template pTemplate="header">
                  <tr>
                    <th>Data Emissão</th>
                    <th>Tipo Tomador</th>
                    <th>CPF/CNPJ</th>
                    <th>Nome Tomador</th>
                    <th>Número NFSe</th>
                    <th>Código Serviço</th>
                    <th>Descrição Serviços</th>
                    <th>Valor Serviço</th>
                  </tr>
                </ng-template>
                
                <ng-template pTemplate="body" let-item>
                  <tr>
                    <td>{{ item.dataEmissao }}</td>
                    <td>{{ item.tipoTomador }}</td>
                    <td>{{ item.cpfTomador || item.cnpjTomador }}</td>
                    <td>{{ item.nomeTomador }}</td>
                    <td>{{ item.numeroNfse }}</td>
                    <td>{{ item.codigoServico }}</td>
                    <td>{{ item.descricaoServicos }}</td>
                    <td>{{ item.valorServico | currency:'BRL' }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>

            <div class="no-data" *ngIf="dadosPlanilha.length === 0 && !loadingPreview">
              <p>Nenhum dado válido encontrado na planilha.</p>
            </div>

            <div class="loading" *ngIf="loadingPreview">
              <p>Carregando dados da planilha...</p>
            </div>

            <div class="action-buttons-preview">
              <button pButton 
                label="Importar Planilha" 
                icon="pi pi-upload" 
                class="p-button-success"
                [disabled]="dadosPlanilha.length === 0"
                (click)="uploadArquivo()">
              </button>
              <button pButton 
                label="Voltar" 
                icon="pi pi-arrow-left" 
                class="p-button-secondary"
                (click)="ocultarPreVisualizacao()">
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="instructions-card">
      <div class="instructions-header">
        <i class="pi pi-info-circle"></i>
        <h3>Instruções Importantes</h3>
      </div>
      <div class="instructions-content">
        <ul class="instructions-list">
          <li>Certifique-se de que a planilha está no formato correto (.xlsx ou .xls)</li>
          <li>O tamanho máximo do arquivo é de 5MB</li>
          <li>Preencha todos os campos obrigatórios na planilha</li>
          <li>Verifique se as datas estão no formato correto (DD/MM/AAAA)</li>
          <li>Use a pré-visualização para verificar os dados antes da importação</li>
        </ul>
      </div>
    </div>
  </div>
